
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/stations-de-ski",
      function () {
        return require("private-next-pages/[region]/stations-de-ski.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/stations-de-ski"])
      });
    }
  